var map = {
	"./board/corner-bottom-left.png": 371,
	"./board/corner-bottom-right.png": 372,
	"./board/corner-top-left.png": 373,
	"./board/corner-top-right.png": 374,
	"./board/hole.png": 375,
	"./board/plank-bottom.png": 376,
	"./board/plank-left.png": 377,
	"./board/plank-right.png": 378,
	"./board/plank-top.png": 379,
	"./buttons/button-large-border.png": 380,
	"./buttons/button-medium-border.png": 381,
	"./buttons/button-nav-border.png": 382,
	"./flag/flag-normal.png": 383,
	"./flag/flag-ripped.png": 384,
	"./gems/border-default.png": 385,
	"./gems/broken-shadow.png": 386,
	"./gems/gem-blue.png": 387,
	"./gems/gem-bronze.png": 388,
	"./gems/gem-caviar.png": 389,
	"./gems/gem-gold.png": 390,
	"./gems/gem-ice.png": 391,
	"./gems/gem-lava.png": 392,
	"./gems/gem-neutral.png": 393,
	"./gems/gem-red.png": 394,
	"./gems/gem-silver.png": 395,
	"./gems/gem-void.png": 396,
	"./logo.png": 397,
	"./logo/logo-full.png": 398,
	"./panel/panel-border-bottom.png": 399,
	"./panel/panel-border-left.png": 400,
	"./panel/panel-border-right.png": 401,
	"./panel/panel-border-top.png": 402,
	"./round-button/round-button-bg-pressed.png": 403,
	"./round-button/round-button-bg.png": 404
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 370;